var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast"},[_c('div',{staticClass:"toast-mask"}),_c('div',{staticClass:"toast-main-container",style:(_vm.styleText)},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }